export enum ExecutionMutations {
  RESET = "RESET",
  SET_EXECUTION_PLAN = "SET_EXECUTION_PLAN",
  POST_EXECUTION_PLAN_MESSAGE = "POST_EXECUTION_PLAN_MESSAGE",
  CERTIFICATE_REQUIRED = "CERTIFICATE_REQUIRED",
}
